import React, { useState, useEffect } from "react";
import { db } from "../../firebase";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";
import "./GPCON_Reviews.css";
import { CgProfile } from "react-icons/cg";

const GPCON_Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [name, setName] = useState("");
  const [comment, setComment] = useState("");
  const [showCount, setShowCount] = useState(3);

  useEffect(() => {
    const fetchReviews = async () => {
      const querySnapshot = await getDocs(collection(db, "reviews"));
      const reviewList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setReviews(reviewList);
    };
    fetchReviews();
  }, []);

  const handleSubmit = async () => {
    if ( comment.trim() === "") return;
    const newReview = {
      name: name.trim() || "Unknown",
      comment,
      likes: 0,
      timestamp: new Date(),
    };
    await addDoc(collection(db, "reviews"), newReview);
    setReviews([newReview, ...reviews]);
    setName("");
    setComment("");
  };

  const handleLike = async (id) => {
    const updatedReviews = reviews.map((review) => {
      if (review.id === id) {
        const newLikes = (review.likes || 0) + 1;
        updateDoc(doc(db, "reviews", id), { likes: newLikes });
        return { ...review, likes: newLikes };
      }
      return review;
    });
    setReviews(updatedReviews);
  };

  return (
    <div className="review-section">
      <div className="review-title">
          <h5>We appreciate your feedback</h5>
          <div className="title-underline-review"></div>
        </div>
        
      <div className="review-container">
        
        <div className="review-list">
        
          {reviews.slice(0, showCount).map((review) => (
            <div key={review.id} className="review-card">
              
              <p>{review.comment}</p>
              <strong  style={{display:"flex",alignItems:"center" ,justifyContent:"center" ,gap:"7px"}}>  
              <strong  style={{fontSize:"20px ",display:"flex", alignItems:"center", justifyContent:"center" }}> ~ </strong>   
               <strong>  {review.name}</strong>
               
            </strong>
              <div className="review-actions">
                <button
                  className="like-button"
                  onClick={() => handleLike(review.id)}
                >
                  👍 {review.likes || 0}
                </button>
              </div>
            </div>
          ))}
          {reviews.length > showCount && (
        
            <button
              className="show-more"
              onClick={() => setShowCount(showCount + 3)}
            >
               Show More
            </button>
          )}
          <h4>  Total {reviews.length} Reviews</h4>
        </div>
        <div className="rs-divider"></div>
        
        <div className="review-form">
          <h3>Write your feedback</h3>
          
          
          <textarea
            placeholder="We’d love to hear your feedback!"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            className="input-field textarea"
          />
          <input
            type="text"
            placeholder="Your Name "
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="input-field"
          />
          <button onClick={handleSubmit} className="reviewsubmit-button">
            Submit My Feedback
          </button>
        </div>
      </div>
    </div>
     );
};

export default GPCON_Reviews;
